import CardActions from '@/components/base/card/card-actions.component';
import { CartSummaryCard } from '../cart-summary-card.component.tsx';
import Button from '@/components/base/button.component';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { useCart } from '@/api/carts/carts.hooks.ts';
import { useTranslation } from 'react-i18next';

export function CartOverviewSummaryCard() {
  const navigate = useNavigate();
  const { t } = useTranslation('cart');
  const { data, isPending } = useCart();
  const cartItems = useMemo(() => data?.cartItems || [], [data]);

  return (
    <CartSummaryCard>
      <CardActions divider={false}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/bp/c/items')}
        >
          {t('actions.continueShopping')}
        </Button>
        <Button
          endIcon={<ArrowForward />}
          onClick={() => navigate('/bp/c/cart/2')}
          variant={'contained'}
          disabled={isPending || cartItems.length === 0}
        >
          {isPending ? t('actions.loading') : t('checkout.continue')}
        </Button>
      </CardActions>
    </CartSummaryCard>
  );
}
